import React, { useState, useEffect } from 'react';
import '../styles/AreaCliente.css';
import Calendario from '../components/Calendario/Calendario';
import InputDocs from '../components/InputDocs/InputDocs';
import Inbox from '../components/Inbox/Inbox';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate, useParams } from 'react-router-dom';
import { db } from '../firebase/firebaseConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faArrowLeft,
    faBriefcase,
    faCalendarCheck,
    faCircleCheck,
    faEnvelopeOpenText,
    faFileArrowUp,
    faFingerprint,
    faIdCard,
    faScaleBalanced,
} from '@fortawesome/free-solid-svg-icons';

const AreaCliente = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [clienteSelecionado, setClienteSelecionado] = useState(null);
    const [loading, setLoading] = useState(true);
    const [erro, setErro] = useState(null);

    useEffect(() => {
        async function validarToken() {
            try {
                const docRef = doc(db, 'tokens', token);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    const data = docSnap.data();
                    const agora = Date.now();

                    if (agora < data.expiracao) {
                        const { clienteId, userEmail } = data;
                        buscarDadosDoCliente(clienteId, userEmail);
                    } else {
                        setErro('Token expirado.');
                    }
                } else {
                    setErro('Token invalido.');
                }
            } catch (error) {
                console.error('Erro ao validar o token:', error);
                setErro('Erro ao validar o token.');
            } finally {
                setLoading(false);
            }
        }

        validarToken();
    }, [token]);

    const buscarDadosDoCliente = async (clienteId, userEmail) => {
        try {
            const clienteRef = doc(db, `usuarios/${userEmail}/clientes`, clienteId);
            const clienteSnap = await getDoc(clienteRef);

            if (clienteSnap.exists()) {
                setClienteSelecionado({ id: clienteId, ...clienteSnap.data() });
            } else {
                setErro('Cliente nao encontrado.');
            }
        } catch (error) {
            console.error('Erro ao buscar dados do cliente:', error);
            setErro('Erro ao buscar dados do cliente.');
        }
    };

    const clienteNome = clienteSelecionado?.nome || 'Cliente';
    const clienteCpf = clienteSelecionado?.cpf || 'CPF nao informado';
    const clienteProcesso = clienteSelecionado?.processo || 'Processo nao informado';

    if (loading) {
        return (
            <main className="main-container-areacliente area-cliente-status-page">
                <section className="area-cliente-status-card" aria-live="polite">
                    <div className="area-cliente-spinner" />
                    <span>Carregando area do cliente...</span>
                </section>
            </main>
        );
    }

    if (erro) {
        return (
            <main className="main-container-areacliente area-cliente-status-page">
                <section className="area-cliente-error-card">
                    <span className="area-cliente-kicker">Acesso indisponivel</span>
                    <h1>{erro}</h1>
                    <p>Confira o link recebido ou solicite um novo acesso ao escritorio.</p>
                    <button className="area-cliente-primary-btn" onClick={() => navigate('/')} type="button">
                        <FontAwesomeIcon icon={faArrowLeft} />
                        <span>Voltar para o inicio</span>
                    </button>
                </section>
            </main>
        );
    }

    return (
        <main className="main-container-areacliente">
            <div className="container-areacliente">
                <section className="area-cliente-hero">
                    <div className="area-cliente-hero-copy">
                        <span className="area-cliente-kicker">Portal do cliente</span>
                        <h1>Ola, {clienteNome}.</h1>
                        <p>Acompanhe agenda, mensagens e documentos do seu atendimento em um unico lugar.</p>
                    </div>

                    <div className="perfil-areacliente" aria-label="Dados do cliente">
                        <div className="perfil-areacliente-header">
                            <span>Resumo do caso</span>
                            <FontAwesomeIcon icon={faCircleCheck} />
                        </div>
                        <div className="perfil-areacliente-list">
                            <div className="perfil-areacliente-item">
                                <FontAwesomeIcon icon={faIdCard} />
                                <div>
                                    <small>Cliente</small>
                                    <strong>{clienteNome}</strong>
                                </div>
                            </div>
                            <div className="perfil-areacliente-item">
                                <FontAwesomeIcon icon={faFingerprint} />
                                <div>
                                    <small>CPF</small>
                                    <strong>{clienteCpf}</strong>
                                </div>
                            </div>
                            <div className="perfil-areacliente-item">
                                <FontAwesomeIcon icon={faBriefcase} />
                                <div>
                                    <small>Processo</small>
                                    <strong>{clienteProcesso}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="area-cliente-stats" aria-label="Acessos principais">
                    <div className="area-cliente-stat">
                        <FontAwesomeIcon icon={faCalendarCheck} />
                        <div>
                            <span>Agenda</span>
                            <p>Compromissos e prazos</p>
                        </div>
                    </div>
                    <div className="area-cliente-stat">
                        <FontAwesomeIcon icon={faFileArrowUp} />
                        <div>
                            <span>Documentos</span>
                            <p>Envios e anexos</p>
                        </div>
                    </div>
                    <div className="area-cliente-stat">
                        <FontAwesomeIcon icon={faEnvelopeOpenText} />
                        <div>
                            <span>Mensagens</span>
                            <p>Contato com o escritorio</p>
                        </div>
                    </div>
                    <div className="area-cliente-stat">
                        <FontAwesomeIcon icon={faScaleBalanced} />
                        <div>
                            <span>Caso</span>
                            <p>Informacoes essenciais</p>
                        </div>
                    </div>
                </section>

                <section className="area-cliente-workspace">
                    <article className="area-cliente-panel area-cliente-panel-calendar">
                        <div className="area-cliente-panel-header">
                            <span>Calendario</span>
                            <p>Veja datas importantes do atendimento.</p>
                        </div>
                        <Calendario />
                    </article>

                    <article className="area-cliente-panel area-cliente-panel-docs">
                        <div className="area-cliente-panel-header">
                            <span>Documentos</span>
                            <p>Envie e acompanhe os arquivos solicitados.</p>
                        </div>
                        <InputDocs />
                    </article>

                    <article className="area-cliente-panel area-cliente-panel-inbox">
                        <div className="area-cliente-panel-header">
                            <span>Inbox</span>
                            <p>Mensagens centralizadas com o escritorio.</p>
                        </div>
                        <Inbox />
                    </article>
                </section>
            </div>
        </main>
    );
};

export default AreaCliente;
